(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  let strings = JSON.parse($('#rot-ui-strings')?.textContent || '{}');
  const currency = document.documentElement.dataset.rotCurrency || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
  const short = value => ({Small:'S',Medium:'M',Large:'L','X-Small':'XS','X-Large':'XL','2X-Large':'2XL','3X-Large':'3XL','XX-Large':'2XL','XXX-Large':'3XL'}[value] || value);
  const motion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.desktop-shop-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  function openDialog(dialog, trigger) {
    if (!dialog) return;
    $$('dialog[open]').forEach(d => d.close());
    const restoreFocus = trigger || document.activeElement;
    dialog.showModal();
    dialog.addEventListener('close', () => {const target=restoreFocus?.getClientRects().length?restoreFocus:$('.store-header .menu-button');target?.focus({preventScroll:true});}, {once:true});
  }
  let backdropPointerDialog = null;
  document.addEventListener('pointerdown', event => {
    const dialog = event.target;
    if (dialog.tagName !== 'DIALOG' || !dialog.open) {
      backdropPointerDialog = null;
      return;
    }
    const rect = dialog.getBoundingClientRect();
    backdropPointerDialog = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom ? dialog : null;
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.desktop-shop-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
    const open = event.target.closest('[data-rot-dialog]');
    if (open) openDialog(document.getElementById(open.dataset.rotDialog), open);
    if (event.target.closest('[data-rot-close]')) event.target.closest('dialog')?.close();
    if (event.target.closest('[data-rot-service]')) event.target.closest('dialog')?.close();
    if (event.target === backdropPointerDialog && event.target.open) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    backdropPointerDialog = null;
    const bag = event.target.closest('[data-rot-bag]');
    if (bag) {
      const drawer = $('cart-drawer');
      if (!drawer) location.href = window.theme?.routes?.cart_url || '/cart';
      else if (!bag.hasAttribute('aria-controls') && drawer.show) drawer.show(bag);
    }
  });
  let cartRead;
  let cartRefreshTimer;
  let redoSyncVersion = 0;
  const setCartText = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };
  const isRedoCoverage = item => /^re:?do$/i.test(String(item.vendor || '').trim()) && /^x-redo/i.test(String(item.sku || ''));
  const validCart = cart => Number.isFinite(cart?.total_price) && Number.isFinite(cart?.item_count) && Array.isArray(cart.items);
  function renderCartSections(cart) {
    const parsed = new Map();
    $$('main-cart,cart-drawer').forEach(container => {
      const section = container.dataset.sectionId;
      const html = cart.sections?.[section];
      if (!html) return;
      if (!parsed.has(section)) parsed.set(section, new DOMParser().parseFromString(html, 'text/html'));
      const id = container.tagName === 'MAIN-CART' ? container.id : 'MiniCart-' + section;
      const current = document.getElementById(id);
      const updated = parsed.get(section).getElementById(id);
      if (!current || !updated) return;
      const restoreFocus = current.contains(document.activeElement);
      current.innerHTML = updated.innerHTML;
      container.closest('.cart')?.classList.toggle('is-empty', cart.item_count === 0);
      if (restoreFocus) current.querySelector('a,button')?.focus({preventScroll:true});
    });
  }
  async function removeOrphanedRedo(cart, root) {
    if (!validCart(cart) || cart.items.some(item => !isRedoCoverage(item))) return cart;
    const coverage = cart.items.filter(isRedoCoverage);
    if (!coverage.length && !cart.attributes?.redo_opted_in_from_cart) return cart;
    if (coverage.some(item => !item.key)) return cart;
    const sections = [...new Set($$('main-cart,cart-drawer').map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
    const response = await fetch(root + 'cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({
        updates:Object.fromEntries(coverage.map(item => [item.key,0])),
        attributes:{redo_opted_in_from_cart:''},
        sections,
        sections_url:location.pathname
      })
    });
    if (!response.ok) return cart;
    const updated = await response.json();
    if (!validCart(updated) || updated.errors) return cart;
    if (sections.some(id => !updated.sections?.[id])) {
      try {
        const sectionResponse = await fetch(location.pathname + '?sections=' + encodeURIComponent(sections.join(',')), {headers:{Accept:'application/json'},cache:'no-store'});
        if (sectionResponse.ok) updated.sections = {...updated.sections,...await sectionResponse.json()};
      } catch {}
    }
    renderCartSections(updated);
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:updated}}));
    return updated;
  }
  async function refreshCount() {
    if (cartRead) return cartRead;
    cartRead = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) return;
        const received = await response.json();
        if (!validCart(received)) return;
        let cart = received;
        try { cart = await removeOrphanedRedo(received, root); } catch {}
        window.rotCartRecovery?.update(cart);
        const subtotal = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:cart.currency || currency}).format(cart.total_price / 100);
        $$('[data-rot-cart-count]').forEach(el => setCartText(el, String(cart.item_count)));
        $$('[data-rot-cart-subtotal]').forEach(el => setCartText(el, subtotal));
        $$('[data-rot-cart-total-count]').forEach(el => setCartText(el, '(' + cart.item_count + ')'));
        return cart;
      } catch {}
    })();
    try { return await cartRead; }
    finally { cartRead = undefined; }
  }
  function queueCartRefresh() {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(refreshCount, 100);
  }
  async function syncRedoCart() {
    const version = ++redoSyncVersion;
    for (const delay of [0,150,350,750,1500,2500]) {
      if (delay) await new Promise(resolve => setTimeout(resolve, delay));
      if (version !== redoSyncVersion || document.hidden) return;
      await refreshCount();
    }
  }
  document.addEventListener('click', event => {
    if (event.target.closest?.('redo-shopify-toggle,[is="cart-remove-button"]')) syncRedoCart();
  }, true);
  document.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.closest?.('redo-shopify-toggle')) syncRedoCart();
  }, true);
  document.addEventListener('cart:updated', queueCartRefresh);
  document.addEventListener('cart:refresh', queueCartRefresh);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) refreshCount();});
  window.addEventListener('pageshow', queueCartRefresh);
  async function addVariant(id, button, status, sellingPlan = null) {
    button.disabled = true;
    const labelNode=button.querySelector('[data-rot-add-label],[data-rot-sticky-label]')||button;
    const label=labelNode.textContent;
    labelNode.textContent=strings.adding;
    if (status) status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sections = $$('cart-drawer').map(d => d.dataset.sectionId).filter(Boolean);
      const response = await fetch(root + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:1,...(sellingPlan?{selling_plan:String(sellingPlan)}:{})}],sections,sections_url:location.pathname})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || strings.error);
      const cart = await refreshCount();
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
      $('#rot-quick-dialog')?.close();
      if (status) status.textContent = strings.updated;
      return true;
    } catch (error) {
      if (status) status.textContent = error.message || strings.error;
      return false;
    } finally {
      labelNode.textContent = label;
      button.disabled = false;
    }
  }
  function notifyVariant(product, variantId, status) {
    if (typeof window._RestockRocket?.openModal !== 'function') {
      if(status)status.textContent=strings.notifyLoading;
      return;
    }
    if(status)status.textContent='';
    window._RestockRocket.openModal(product,String(variantId));
  }
  function vipInit(form) {
    if(form.dataset.rotReady)return;
    form.dataset.rotReady='true';
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const values=new FormData(form), status=$('[data-rot-vip-status]',form);
      const plan=values.get('selling_plan');
      if(!plan){status.textContent=strings.vipPlanMissing;return;}
      await addVariant(values.get('id'),$('button[type="submit"]',form),status,plan);
    });
  }
  function productInit(root) {
    if (root.dataset.rotReady) return;
    const dataNode=$('[data-rot-product-data]',root);
    const form=$('.rot-product-form',root);
    if(!dataNode||!form)return;
    const data=JSON.parse(dataNode.textContent);
    const notifyProduct=JSON.parse($('[data-rot-stoq-product]',root).textContent);
    root.dataset.rotReady='true';
    document.dispatchEvent(new CustomEvent('rot:product-ready'));
    const stickyBar=$('.sticky-buy',root);
    const footer=$('footer');
    if(stickyBar&&footer&&'IntersectionObserver' in window){
      const footerObserver=new IntersectionObserver(entries=>{stickyBar.hidden=entries[0].isIntersecting;});
      footerObserver.observe(footer);
    }
    const chartLink=$('[data-rot-open-chart]',root);
    const chartSrc=$$('.rot-chart-content img',root).map(image=>image.currentSrc||image.getAttribute('src')||image.getAttribute('data-src')).find(src=>src&&!src.startsWith('data:'));
    if(chartSrc&&chartLink)chartLink.href=chartSrc;
    let chosen;
    function choose(size, updateUrl = true) {
      chosen = data.variants.find(v => v.options[data.sizeIndex] === size);
      if (!chosen) return;
      $('[name="id"]',form).value = chosen.id;
      $$('[data-rot-size-label]',root).forEach(el=>el.textContent=short(size));
      $$('[data-rot-size]',root).forEach(b => {
        const selected = b.dataset.rotSize === size;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('selected', selected);
      });
      $('[data-rot-price]',root).textContent = money(chosen.price);
      const stickyPrice=$('[data-rot-sticky-price]',root);
      if(stickyPrice)stickyPrice.textContent=money(chosen.price);
      const stickyLabel=$('[data-rot-sticky-label]',root);
      if(stickyLabel)stickyLabel.textContent=chosen.available?strings.add:strings.notify;
      root.dispatchEvent(new CustomEvent('rot:variant-change'));
      const add = $('[data-rot-add]',root);
      if(add){add.disabled=false;$('[data-rot-add-label]',root).textContent=chosen.available?strings.add:strings.notify;}
      $$('[data-rot-color-link]',root).forEach(link => {
        const variants = JSON.parse(link.dataset.variants);
        const variant = variants.find(v => v.options[Number(link.dataset.sizeIndex)] === size);
        const available=Boolean(variant?.available);
        link.classList.toggle('rot-color-unavailable',!available);
        const colorLabel=link.dataset.colorName+(available?'':' — '+strings.unavailableIn+' '+short(size));
        link.setAttribute('aria-label',colorLabel);link.title=colorLabel;
        if (variant) {
          const url = new URL(link.href);
          url.searchParams.set('variant',variant.id);
          link.href = url.pathname + url.search;
        }
      });
      const stockNote=$('[data-rot-swatch-stock-note]',root);if(stockNote)stockNote.hidden=!$('.rot-color-unavailable',root);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', chosen.id);
        history.replaceState(null,'',url.pathname + url.search + url.hash);
      }
      form.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant:chosen}}));
    }
    $$('[data-rot-size]',root).forEach(button => {
      const variant = data.variants.find(v => v.options[data.sizeIndex] === button.dataset.rotSize);
      if (!variant?.available) {
        button.classList.add('rot-unavailable-size');
        button.setAttribute('aria-label',short(button.dataset.rotSize) + ' — ' + strings.sold);
      }
      button.addEventListener('click', () => choose(button.dataset.rotSize));
    });
    if (data.selectedSize) choose(data.selectedSize,false);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if(data.vipRestricted||!chosen)return;
      if(!chosen.available){notifyVariant(notifyProduct,chosen.id,$('.rot-form-status',root));return;}
      await addVariant(chosen.id,$('[data-rot-add]',root),$('.rot-form-status',root));
    });
    $('[data-rot-sticky-add]',root)?.addEventListener('click',async event=>{
      if(data.vipRestricted)return;
      if(chosen&&!chosen.available){notifyVariant(notifyProduct,chosen.id,$('.rot-form-status',root));return;}
      if(chosen?.available)await addVariant(chosen.id,event.currentTarget,$('.rot-form-status',root));
      else{$('.size-heading',root).scrollIntoView({behavior:motion(),block:'center'});$('[data-rot-size]',root)?.focus({preventScroll:true});}
    });
    const mainImage = $('.main-product-image',root);
    const photos=$$('[data-rot-image]',root);
    const gallery=$('[data-rot-carousel]',root);
    const galleryFrame=$('.gallery-main',root);
    if(gallery&&galleryFrame&&mainImage){
      const syncGalleryWidth=()=>{
        if(!mainImage.naturalWidth||!mainImage.naturalHeight)return;
        const frame=galleryFrame.getBoundingClientRect();
        const width=Math.min(frame.width,frame.height*mainImage.naturalWidth/mainImage.naturalHeight);
        if(width>0)gallery.style.setProperty('--rot-photo-width',Math.round(width)+'px');
      };
      mainImage.addEventListener('load',()=>requestAnimationFrame(syncGalleryWidth));
      if('ResizeObserver' in window)new ResizeObserver(syncGalleryWidth).observe(galleryFrame);
      if(mainImage.complete)requestAnimationFrame(syncGalleryWidth);
    }
    let photoIndex=0;
    function showPhoto(index,focus=false){
      if(!photos.length)return;
      photoIndex=Math.max(0,Math.min(index,photos.length-1));
      const button=photos[photoIndex];
      const videoHost=$('[data-rot-video-host]',root);
      videoHost?.querySelectorAll('video').forEach(video=>video.pause());
      videoHost?.replaceChildren();
      const isVideo=!!button.dataset.rotVideoTarget;
      mainImage.hidden=isVideo;
      if(videoHost)videoHost.hidden=!isVideo;
      const videoNote=$('[data-rot-video-note]',root);if(videoNote)videoNote.hidden=!isVideo;
      if(isVideo){
        const template=document.getElementById(button.dataset.rotVideoTarget);
        if(template?.content&&videoHost){
          videoHost.append(template.content.cloneNode(true));
          const video=$('video',videoHost);
          if(video){
            video.muted=true;
            video.defaultMuted=true;
            video.autoplay=true;
            video.playsInline=true;
            video.controls=false;
            video.loop=true;
            video.tabIndex=0;
            video.setAttribute('role','button');
            const label=()=>video.setAttribute('aria-label',video.paused?strings.playVideo:strings.pauseVideo);
            const play=()=>{const attempt=video.play();if(attempt?.catch)attempt.catch(label);};
            const toggle=()=>video.paused?play():video.pause();
            video.addEventListener('play',label);
            video.addEventListener('pause',label);
            video.addEventListener('click',toggle);
            video.addEventListener('keydown',event=>{if(event.key===' '||event.key==='Enter'){event.preventDefault();toggle();}});
            label();
            play();
          }
        }
      }else{
        const url=new URL(button.dataset.rotImage,location.origin);
        mainImage.src=button.dataset.rotImage;
        if(url.pathname.includes('/files/')||url.pathname.includes('/products/'))mainImage.srcset=[480,720,960,1400,2000,2400].map(width=>{const sized=new URL(url);sized.searchParams.set('width',String(width));return sized.href+' '+width+'w';}).join(', ');
        else mainImage.removeAttribute('srcset');
      }
      photos.forEach(b=>{b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button));});
      $('[data-rot-photo-index]',root).textContent=String(photoIndex+1);
      $('[data-rot-photo-prev]',root).disabled=photoIndex===0;
      $('[data-rot-photo-next]',root).disabled=photoIndex===photos.length-1;
      if(focus)button.focus({preventScroll:true});
      button.scrollIntoView({behavior:motion(),block:'nearest',inline:'nearest'});
    }
    if(gallery){
      $('[data-rot-photo-total]',root).textContent=String(photos.length);
      $('[data-rot-photo-prev]',root).disabled=true;
      $('[data-rot-photo-next]',root).disabled=photos.length<2;
      photos.forEach((button,index)=>button.addEventListener('click',()=>showPhoto(index)));
      $('[data-rot-photo-prev]',root).addEventListener('click',()=>showPhoto(photoIndex-1));
      $('[data-rot-photo-next]',root).addEventListener('click',()=>showPhoto(photoIndex+1));
      gallery.addEventListener('keydown',event=>{if(event.target.closest('video,iframe,input,textarea'))return;if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showPhoto(photoIndex+(event.key==='ArrowRight'?1:-1),true);}});
      let pointerStart;
      const main=$('.gallery-main',root);
      main.addEventListener('pointerdown',event=>{if(event.target.closest('video,iframe,button'))return;pointerStart={x:event.clientX,y:event.clientY};});
      main.addEventListener('pointerup',event=>{if(!pointerStart)return;const dx=event.clientX-pointerStart.x,dy=event.clientY-pointerStart.y;pointerStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)showPhoto(photoIndex+(dx<0?1:-1));});
      main.addEventListener('pointercancel',()=>{pointerStart=null;});
    }
  }
  $$('[data-rot-cookie-preferences]').forEach(button=>button.addEventListener('click',async()=>{
    if(!window.privacyBanner?.showPreferences){
      button.disabled=true;
      await new Promise(resolve=>{
        const existing=$('script[src*="privacy-banner/storefront-banner.js"]');
        if(existing)existing.addEventListener('load',resolve,{once:true});
        else{const script=document.createElement('script');script.src='/cdn/shopifycloud/privacy-banner/storefront-banner.js';script.onload=resolve;script.onerror=resolve;document.head.append(script);}
        setTimeout(resolve,4000);
      });
      button.disabled=false;
    }
    if(window.privacyBanner?.showPreferences)window.privacyBanner.showPreferences();
    else location.href='/pages/ccpa-opt-out';
  }));
  $$('[data-rot-sharing-optout]').forEach(button=>button.addEventListener('click',async()=>{
    const status=$('[data-rot-sharing-status]');
    button.disabled=true;
    try{
      if(!window.Shopify?.customerPrivacy){
        await new Promise((resolve,reject)=>{
          const timeout=setTimeout(()=>reject(new Error('Privacy API unavailable')),5000);
          if(!window.Shopify?.loadFeatures){clearTimeout(timeout);reject(new Error('Privacy API unavailable'));return;}
          window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{clearTimeout(timeout);error?reject(error):resolve();});
        });
      }
      await new Promise((resolve,reject)=>{
        const timeout=setTimeout(()=>reject(new Error('Privacy choice not saved')),5000);
        window.Shopify.customerPrivacy.setTrackingConsent({sale_of_data:false},result=>{clearTimeout(timeout);result?.error?reject(new Error(result.error)):resolve();});
      });
      if(status)status.textContent=button.dataset.success;
    }catch{
      if(status)status.textContent=button.dataset.error;
    }finally{button.disabled=false;}
  }));
  let quickSelection;
  let quickColor;
  function quick(color, trigger) {
    if(color.vipExclusive){location.href='/pages/vip-membership';return;}
    quickColor=color;
    const dialog = $('#rot-quick-dialog');
    if (!dialog) return;
    quickSelection = null;
    $('#rot-quick-title').textContent = color.name;
    $('[data-rot-quick-image]').src = color.image;
    $('[data-rot-quick-image]').alt = color.name + ' / ' + color.color;
    $('[data-rot-quick-color]').textContent = color.color;
    $('[data-rot-quick-price]').textContent = money(color.price);
    $('[data-rot-quick-link]').href = color.url;
    const sizes = $('[data-rot-quick-sizes]');
    sizes.replaceChildren();
    sizes.toggleAttribute('data-rot-waist-sizes',color.variants.some(v=>v.size.includes('(')));
    const confirm = $('[data-rot-quick-add]');
    confirm.textContent = strings.select;
    confirm.disabled = true;
    $('[data-rot-quick-status]').textContent = '';
    color.variants.forEach(variant => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'size';
      button.textContent = short(variant.size) || 'One size';
      if(!variant.available){button.classList.add('rot-unavailable-size');button.setAttribute('aria-label',short(variant.size)+' — '+strings.sold);}
      button.setAttribute('aria-pressed','false');
      button.addEventListener('click', () => {
        quickSelection = variant;
        $$('button',sizes).forEach(b => {b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button));});
        $('[data-rot-quick-price]').textContent = money(variant.price);
        confirm.textContent=variant.available?strings.add+' — '+money(variant.price):strings.notify;
        confirm.disabled = false;
      });
      sizes.append(button);
    });
    openDialog(dialog,trigger);
  }
  $('[data-rot-quick-add]')?.addEventListener('click',async event => {
    if(quickSelection&&!quickSelection.available){
      const product={id:Number(quickColor.id),title:quickColor.name+': '+quickColor.color,handle:quickColor.handle,images:[quickColor.image],options:['Size'],variants:quickColor.variants.map(v=>({...v,title:v.size,option1:v.size,options:[v.size]}))};
      $('#rot-quick-dialog')?.close();notifyVariant(product,quickSelection.id,$('[data-rot-quick-status]'));return;
    }
    if (quickSelection?.available) await addVariant(quickSelection.id,event.currentTarget,$('[data-rot-quick-status]'));
  });
  function cardInit(card) {
    if (card.rotRecord) return card.rotRecord;
    const colors = JSON.parse($('[data-rot-card-data]',card).textContent);
    const url = $('[data-rot-card-link]',card).getAttribute('href');
    const initial = colors.find(c => url.split('?')[0].endsWith('/'+c.handle)) || colors[0];
    const record = {el:card,colors,selected:initial,initial,family:card.dataset.family,fit:card.dataset.fit,neckline:card.dataset.neckline,hem:card.dataset.hem};
    card.rotRecord = record;
    function select(color) {
      record.selected = color;
      const image = $('.catalog-card-photo img',card);
      const imageBase=new URL(color.image,location.origin);
      image.src=color.image;
      if(imageBase.hostname==='ruleofthreads.com'||imageBase.hostname==='cdn.shopify.com'){
        image.srcset=[240,360,540,720].map(width=>{const url=new URL(imageBase);url.searchParams.set('width',String(width));return url.href+' '+width+'w';}).join(', ');
      }
      image.alt = color.name + ' / ' + color.color;
      $$('[data-rot-card-link]',card).forEach(a => a.href = color.url);
      $('[data-rot-card-price]',card).textContent = money(color.price);
      $('[data-rot-card-color]:not(button)',card).textContent = color.color;
      const allowed = record.allowedColors || colors;
      const allowedHandles = new Set(allowed.map(c=>c.handle));
      const choices=$$('button[data-rot-card-color]',card);
      const eligibleChoices=choices.filter(b=>allowedHandles.has(b.dataset.rotCardColor));
      const selectedIndex=eligibleChoices.findIndex(b=>b.dataset.rotCardColor===color.handle);
      choices.forEach(b=>{
        b.setAttribute('aria-pressed',String(b.dataset.rotCardColor===color.handle));
        const index=eligibleChoices.indexOf(b);
        b.hidden=index<0||(card.dataset.rotColorsExpanded!=='true'&&index>=(selectedIndex>=6?5:6)&&b.dataset.rotCardColor!==color.handle);
      });
      const colorCount=$('[data-rot-card-color-count]',card);
      if(colorCount){colorCount.hidden=allowed.length<=1;colorCount.textContent=' · '+allowed.length+' '+strings.colors;}
      const expand=$('[data-rot-expand-colors]',card);
      if(expand){expand.dataset.rotExpandLabel ||= expand.getAttribute('aria-label');const expanded=card.dataset.rotColorsExpanded==='true';expand.hidden=allowed.length<=6;expand.textContent=expanded?strings.less:'+'+(allowed.length-6);expand.setAttribute('aria-label',expanded?strings.less+' '+strings.colors:expand.dataset.rotExpandLabel);}
      const add = $('[data-rot-quick]',card);
      if (add) {
        add.disabled=false;
        const label=document.createTextNode(color.vipExclusive?strings.vipExclusive:color.variants.some(v=>v.available)?strings.chooseSize:strings.notify);
        add.replaceChildren(label);
        if(!add.disabled){const icon=document.createElement('span');icon.setAttribute('aria-hidden','true');icon.textContent='+';add.append(' ',icon);}
      }
    }
    record.select = select;
    $('[data-rot-expand-colors]',card)?.addEventListener('click',event=>{
      const expanded=card.dataset.rotColorsExpanded!=='true';card.dataset.rotColorsExpanded=String(expanded);event.currentTarget.setAttribute('aria-expanded',String(expanded));event.currentTarget.textContent=expanded?strings.less:'+'+(colors.length-6);select(record.selected);
    });
    $$('button[data-rot-card-color]',card).forEach(button => button.addEventListener('click', () => select(colors.find(c => c.handle===button.dataset.rotCardColor))));
    $('[data-rot-quick]',card)?.addEventListener('click',event => quick(record.selected,event.currentTarget));
    return record;
  }
  function catalogInit(root) {
    if (root.dataset.rotReady) return;
    root.dataset.rotReady = 'true';
    const records = $$('[data-rot-card]',root).map(cardInit);
    const multi = root.dataset.collection !== 'search';
    const filterButton = $('[data-rot-toggle-filters]',root);
    filterButton?.addEventListener('click',event=>{
      const panel=$('.collection-filters',root);
      const expanded=!panel.classList.contains('open');
      panel.classList.toggle('open',expanded);
      event.currentTarget.setAttribute('aria-expanded',String(expanded));
    });
    const queryTerm = (root.dataset.searchTerms || '').trim().toLocaleLowerCase();
    const queryColor = queryTerm ? records.flatMap(r=>r.colors).find(c=>c.color.toLocaleLowerCase()===queryTerm)?.color : undefined;
    const queryWords=queryTerm.split(/\s+/).filter(Boolean);
    const directMatch=(record,color)=>{
      const fields=[record.family,record.fit,color.name,color.color,color.handle?.replaceAll('-',' ')].filter(Boolean).join(' ').toLocaleLowerCase();
      return queryWords.every(word=>fields.includes(word));
    };
    const hasDirectMatch=queryWords.length>0&&records.some(record=>record.colors.some(color=>directMatch(record,color)));
    const matchData=$('[data-rot-search-result-ids]',root);
    const matchedProductIds=matchData?new Set(JSON.parse(matchData.textContent).map(String)):null;
    const params = new URLSearchParams(location.search);
    const list=key=>[...new Set(params.getAll(key).flatMap(value=>value.split(',')).filter(value=>value&&value!=='All'))];
    const defaultFamily=({'origin-t-shirts':'Origin','odyssey-t-shirts':'Odyssey','apollo-t-shirts':'Apollo','zero-g-shirts':'Zero-G','legacy-polos':'Legacy'}[root.dataset.collection]||'All');
    const colorGroups={
      black:['Black','Dark Matter'],
      white:['White','Off White','Bone','Stone','Cream'],
      gray:['Asteroid','Carbon','Granite','Space Gray','Gotham Gray'],
      blue:['Aqua','Astro Blue','Charcoal Navy','Charcoal Blue','Cosmo','Ice','NY Blue','Retro Blue','Navy'],
      green:['Dark Moss','Eucalyptus','Forest','Olive Drab','Moss','Sage'],
      brown:['Canyon','Driftwood','Dust','Espresso','Khaki','Mochavino','Taupe','Mocha','Sandstone'],
      red:['Crimson','Flare'],purple:['Mauve','Plum'], 'orange-yellow':['Apricot','Sol']
    };
    const colorGroup=name=>Object.entries(colorGroups).find(([,names])=>names.includes(name))?.[0]||'other';
    const colorKeys=new Set([...Object.keys(colorGroups),'other']);
    const state = {
      family:params.get('family')||defaultFamily,
      fit:list('fit').length?list('fit'):(root.dataset.initialFit?[root.dataset.initialFit]:[]),
      neckline:list('neckline'),hem:list('hem'),size:list('size'),
      color:multi?list('color').map(value=>colorKeys.has(value)?value:colorGroup(value)):list('color'),
      available:params.get('available')==='1',sort:params.get('sort')||(params.get('sort_by')==='best-selling'?'best-selling':'featured')
    };
    const sizeSelect=$('[data-rot-size-filter]',root);
    const colorSelect=$('[data-rot-color-filter]',root);
    const necklineSelect=$('[data-rot-neckline-filter]',root);
    const hemSelect=$('[data-rot-hem-filter]',root);
    const sizes=[...new Set(records.flatMap(r=>r.colors.flatMap(c=>c.variants.map(v=>short(v.size)))))].filter(Boolean);
    const order=['XS','S','M','L','XL','2XL','3XL'];
    sizes.sort((a,b)=>(order.includes(a)?order.indexOf(a):99)-(order.includes(b)?order.indexOf(b):99)||a.localeCompare(b));
    if(sizeSelect)sizes.forEach(size=>sizeSelect.add(new Option(size,size)));
    if(colorSelect)[...new Set(records.flatMap(r=>r.colors.map(c=>c.color)))].filter(Boolean).sort().forEach(color=>colorSelect.add(new Option(color,color)));
    const sizeOptions=$('[data-rot-filter-options="size"]',root);
    if(sizeOptions)sizes.forEach(size=>{
      const label=document.createElement('label');label.className='rot-filter-choice';
      const input=document.createElement('input');input.type='checkbox';input.dataset.rotFilter='size';input.value=size;
      const text=document.createElement('span');text.textContent=size;
      label.append(input,text);sizeOptions.append(label);
    });
    function eligible(record) {
      return record.colors.filter(c=>(!hasDirectMatch||directMatch(record,c))&&(!matchedProductIds||matchedProductIds.has(String(c.id)))&&(!queryColor||c.color===queryColor)&&(!state.color.length||state.color.includes(multi?colorGroup(c.color):c.color))&&(!state.size.length||c.variants.some(v=>state.size.includes(short(v.size))&&v.available))&&(!state.available||c.variants.some(v=>v.available)));
    }
    function writeUrl(url) {
      for(const key of ['family','fit','neckline','hem','size','color','available','sort']){
        const value=state[key];
        if(Array.isArray(value)?!value.length:(!value||value==='All'||value==='featured'))url.searchParams.delete(key);
        else url.searchParams.set(key,Array.isArray(value)?value.join(','):key==='available'?'1':value);
      }
      return url;
    }
    function nativeSort() {
      if(!multi)return false;
      const url=writeUrl(new URL(location.href));
      if(state.sort==='best-selling'&&url.searchParams.get('sort_by')!=='best-selling'){
        url.searchParams.set('sort_by','best-selling');location.assign(url.href);return true;
      }
      if(state.sort==='featured'&&url.searchParams.has('sort_by')){
        url.searchParams.delete('sort_by');location.assign(url.href);return true;
      }
      return false;
    }
    function render(updateUrl=true) {
      const familyRecords=records.filter(r=>state.family==='All'||r.family===state.family);
      const fits=new Set(familyRecords.map(r=>r.fit));
      state.fit=state.fit.filter(value=>fits.has(value));
      const valuesByKey={
        neckline:new Set(familyRecords.map(r=>r.neckline).filter(Boolean)),
        hem:new Set(familyRecords.map(r=>r.hem).filter(Boolean)),
        color:new Set(familyRecords.flatMap(r=>r.colors.map(c=>multi?colorGroup(c.color):c.color))),
        size:new Set(sizes)
      };
      for(const [key,select] of [['neckline',necklineSelect],['hem',hemSelect]]){
        state[key]=state[key].filter(value=>valuesByKey[key].has(value));
        if(select){Array.from(select.options).forEach(option=>option.disabled=!!option.value&&!valuesByKey[key].has(option.value));select.value=state[key][0]||'';}
      }
      $$('[data-rot-fit]',root).forEach(button=>{
        const value=button.dataset.rotFit;
        button.disabled=value!=='All'&&!fits.has(value);
        button.setAttribute('aria-pressed',String(value==='All'?!state.fit.length:state.fit.includes(value)));
      });
      const fitSelect=$('[data-rot-fit-select]',root);
      if(fitSelect){Array.from(fitSelect.options).forEach(option=>option.disabled=option.value!=='All'&&!fits.has(option.value));fitSelect.value=state.fit[0]||'All';}
      $$('[data-rot-family]',root).forEach(a=>a.setAttribute('aria-current',String(state.family===a.dataset.rotFamily)));
      if(sizeSelect)sizeSelect.value=state.size[0]||'';
      if(colorSelect)colorSelect.value=state.color[0]||'';
      const familySelect=$('[data-rot-family-select]',root);
      if(familySelect)familySelect.value=state.family;
      $('[data-rot-available]',root).checked=state.available;
      $('[data-rot-sort]',root).value=state.sort;
      $$('[data-rot-filter]',root).forEach(input=>{
        const key=input.dataset.rotFilter;
        input.checked=state[key].includes(input.value);
        const present=valuesByKey[key].has(input.value);
        input.disabled=!present&&!input.checked;
        input.closest('label').hidden=!present&&!input.checked;
      });
      $$('[data-rot-filter-count]',root).forEach(count=>{
        const number=state[count.dataset.rotFilterCount].length;
        count.hidden=!number;count.textContent=String(number);
      });
      const total=state.fit.length+state.neckline.length+state.hem.length+state.size.length+state.color.length+Number(state.available);
      const totalLabel=$('[data-rot-filter-total]',root);
      if(totalLabel){totalLabel.textContent='('+total+')';totalLabel.hidden=!total;}
      const visible=[];
      records.forEach(record=>{
        const colors=eligible(record);
        const shown=(state.family==='All'||record.family===state.family)&&(!state.fit.length||state.fit.includes(record.fit))&&(!state.neckline.length||state.neckline.includes(record.neckline))&&(!state.hem.length||state.hem.includes(record.hem))&&colors.length>0;
        record.el.hidden=!shown;
        if(shown){
          const selected=colors.find(c=>c.handle===record.selected.handle)||colors.find(c=>c.handle===record.initial.handle)||colors[0];
          record.allowedColors=colors;record.select(selected);visible.push(record);
        }
      });
      if(state.sort==='price-asc')visible.sort((a,b)=>a.selected.price-b.selected.price);
      if(state.sort==='price-desc')visible.sort((a,b)=>b.selected.price-a.selected.price);
      if(state.sort==='name')visible.sort((a,b)=>a.selected.name.localeCompare(b.selected.name));
      const grid=$('[data-rot-grid]',root);
      (['featured','best-selling'].includes(state.sort)?records:visible).forEach(record=>grid.append(record.el));
      const matchingColors=visible.reduce((sum,record)=>sum+eligible(record).length,0);
      $('[data-rot-result-count]',root).textContent=visible.length+' '+(visible.length===1?(root.dataset.itemLabel||strings.style):(root.dataset.itemsLabel||strings.styles))+(root.dataset.collection==='search'?' · '+matchingColors+' '+(matchingColors===1?strings.matchingColor:strings.matchingColors):'');
      $('[data-rot-empty]',root).hidden=visible.length>0;
      if(updateUrl){const url=writeUrl(new URL(location.href));history.replaceState(null,'',url.pathname+url.search+url.hash);}
    }
    $$('[data-rot-family]',root).forEach(a=>a.addEventListener('click',event=>{
      if(root.dataset.collection!=='all-apparel')return;
      event.preventDefault();state.family=a.dataset.rotFamily;render();
    }));
    $$('[data-rot-fit]',root).forEach(button=>button.addEventListener('click',()=>{
      const value=button.dataset.rotFit;
      state.fit=value==='All'?[]:multi?(state.fit.includes(value)?state.fit.filter(fit=>fit!==value):[...state.fit,value]):[value];render();
    }));
    root.addEventListener('change',event=>{
      const input=event.target.closest('[data-rot-filter]');
      if(!input)return;
      const key=input.dataset.rotFilter;
      state[key]=input.checked?[...new Set([...state[key],input.value])]:state[key].filter(value=>value!==input.value);render();
    });
    [['[data-rot-neckline-filter]','neckline'],['[data-rot-hem-filter]','hem'],['[data-rot-size-filter]','size'],['[data-rot-color-filter]','color'],['[data-rot-sort]','sort'],['[data-rot-fit-select]','fit'],['[data-rot-family-select]','family']].forEach(([selector,key])=>$(selector,root)?.addEventListener('change',event=>{
      state[key]=['family','sort'].includes(key)?event.target.value:(event.target.value&&event.target.value!=='All'?[event.target.value]:[]);
      if(key==='sort'&&nativeSort())return;
      render();
    }));
    $('[data-rot-available]',root).addEventListener('change',event=>{state.available=event.target.checked;render();});
    $$('[data-rot-reset]',root).forEach(button=>button.addEventListener('click',()=>{
      Object.assign(state,{family:defaultFamily,fit:[],neckline:[],hem:[],size:[],color:[],available:false,sort:'featured'});
      if(!nativeSort())render();
    }));
    render(false);
  }
  function reviewInit(){
    const full=$('[data-rot-full-reviews]');
    if(!full||full.dataset.rotReviewReady)return;
    full.dataset.rotReviewReady='true';
    const sync=()=>{
      const widget=$('.jdgm-rev-widg',full);
      const count=Number(widget?.dataset.numberOfReviews);
      const rating=Number(widget?.dataset.averageRating);
      if(count>0&&Number.isFinite(rating)){
        $('[data-rot-review-summary]').hidden=false;
        $('[data-rot-review-average]').textContent=rating.toFixed(2);
        $('[data-rot-review-stars]').textContent='★'.repeat(Math.round(rating));
        $('[data-rot-review-count]').textContent=count;
      }
      const first=$('.jdgm-rev',full);
      if(!first)return;
      const body=$('.jdgm-rev__body',first)?.textContent.trim();
      const sentence=body?.match(/^.*?[.!?](?:\s|$)/)?.[0].trim()||body;
      if(sentence)$('[data-rot-review-quote]').textContent='“'+sentence+'”';
      const author=$('.jdgm-rev__author',first)?.textContent.trim();
      const date=$('.jdgm-rev__timestamp',first)?.getAttribute('datetime');
      const dateText=date?new Intl.DateTimeFormat(document.documentElement.lang||'en-US',{year:'numeric',month:'long',day:'numeric'}).format(new Date(date)):'';
      $('[data-rot-review-author]').textContent=[author,first.dataset.verifiedBuyer==='true'?strings.verified:'',dateText].filter(Boolean).join(' · ');
      const current=$('[data-rot-color-link][aria-current]')?.dataset.colorName||'';
      const purchased=first.dataset.productTitle?.split(':').slice(1).join(':').trim()||first.dataset.productTitle||'';
      $('[data-rot-review-context]').textContent=current&&purchased?(strings.review_context||'').replace('[current]',current).replace('[purchased]',purchased):first.dataset.productTitle||'';
      $('[data-rot-feature-stars]').textContent='★'.repeat(Number($('.jdgm-rev__rating',first)?.dataset.score)||0);
    };
    sync();
    new MutationObserver(sync).observe(full,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
    $('[data-rot-review-toggle]')?.addEventListener('click',()=>{full.hidden=!full.hidden;if(!full.hidden)full.scrollIntoView({behavior:motion(),block:'start'});});
  }
  function init(root=document) {
    const ui=$('#rot-ui-strings');
    if(ui)strings=JSON.parse(ui.textContent);
    $$('[data-rot-product]',root).forEach(productInit);
    $$('.rot-vip-form',root).forEach(vipInit);
    $$('[data-rot-card]',root).forEach(cardInit);
    $$('[data-rot-catalog]',root).forEach(catalogInit);
    $$('.fit-options button[data-fit]',root).forEach(button=>button.addEventListener('click',()=>location.href='/pages/fit-quiz?view=rot-fit'));
  }
  function archiveInit() {
    const marker=$('[data-rot-drop-archive]');
    if(!marker||marker.dataset.rotReady)return;
    marker.dataset.rotReady='true';
    const wrapper=marker.closest('.shopify-section');
    if(!wrapper)return;
    const older=[];
    for(let section=wrapper.nextElementSibling;section;section=section.nextElementSibling)older.push(section);
    const button=$('[data-rot-archive-toggle]',marker);
    button.setAttribute('aria-controls',older.map(section=>section.id).filter(Boolean).join(' '));
    function show(open){
      older.forEach(section=>section.hidden=!open);
      button.setAttribute('aria-expanded',String(open));
      button.replaceChildren(document.createTextNode(open?button.dataset.closeLabel:button.dataset.openLabel));
      const icon=document.createElement('span');icon.setAttribute('aria-hidden','true');icon.textContent=open?'−':'＋';button.append(icon);
    }
    show(Boolean(window.Shopify?.designMode));
    button.addEventListener('click',()=>show(button.getAttribute('aria-expanded')!=='true'));
    document.addEventListener('shopify:section:select',event=>{if(older.includes(event.target))show(true);});
  }
  function keepStoreLinkInTab(link){
    if(!link?.matches?.('a[href][target]'))return;
    try{
      const url=new URL(link.getAttribute('href'),location.href);
      const storeHost=url.hostname.replace(/^www\./,'');
      const currentHost=location.hostname.replace(/^www\./,'');
      if((storeHost===currentHost||storeHost==='ruleofthreads.com')&&!url.pathname.startsWith('/apps/redo/'))link.removeAttribute('target');
    }catch{}
  }
  function normalizeStoreLinks(root){
    keepStoreLinkInTab(root);
    root.querySelectorAll?.('a[href][target]').forEach(keepStoreLinkInTab);
  }
  function brandAccountDrawer(){
    $$('.kl-hub-drawer').forEach(drawer=>{
      const header=$('.kl-hub-drawer__header',drawer);
      if(header&&!header.parentElement.classList.contains('rot-hub-header-container'))header.parentElement.classList.add('rot-hub-header-container');
      const logo=$('.store-header .wordmark');
      if(header&&logo&&!header.querySelector('.rot-hub-wordmark')){
        const brand=document.createElement('a');brand.className='rot-hub-wordmark';brand.href=window.Shopify?.routes?.root||'/';brand.append(logo.cloneNode(true));header.prepend(brand);
      }
      $$('h1,h2,h3,.kl-hub-heading',drawer).forEach(heading=>{
        if(/^view\s+orders[.!]?$/i.test(heading.textContent.trim())||/^earn rewards, track orders, and save your shopping history[.!]?$/i.test(heading.textContent.trim())){
          heading.classList.add('rot-hub-sign-in-heading');
          heading.textContent=strings.accountSignIn;
        }
      });
    });
  }
  document.addEventListener('click',event=>keepStoreLinkInTab(event.target.closest?.('a[href]')),true);
  if(document.body)new MutationObserver(records=>{
    let accountChanged=false;
    records.forEach(record=>{
      if(record.type==='attributes')keepStoreLinkInTab(record.target);
      if(record.target.closest?.('.kl-hub-drawer'))accountChanged=true;
      record.addedNodes.forEach(node=>{
        if(node.nodeType!==1)return;
        normalizeStoreLinks(node);
        if(node.matches?.('.kl-hub-drawer')||node.querySelector?.('.kl-hub-drawer'))accountChanged=true;
      });
    });
    if(accountChanged)brandAccountDrawer();
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['target']});
  function boot(){init();reviewInit();archiveInit();brandAccountDrawer();normalizeStoreLinks(document);const fitQuiz=document.getElementById('quizellIframe');if(fitQuiz&&!fitQuiz.title)fitQuiz.title=document.title;}
  boot();
  document.addEventListener('DOMContentLoaded',boot,{once:true});
  document.addEventListener('shopify:section:load',boot);
  const content=document.getElementById('MainContent');
  if(content)new MutationObserver(records=>{
    if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches?.('[data-rot-product],[data-rot-catalog],[data-rot-full-reviews],#quizellIframe')||node.querySelector?.('[data-rot-product],[data-rot-catalog],[data-rot-full-reviews],#quizellIframe')))))boot();
  }).observe(content,{childList:true,subtree:true});
  const cartDrawer=$('cart-drawer');
  if (cartDrawer) new MutationObserver(queueCartRefresh).observe(cartDrawer,{childList:true,subtree:true});
})();

